import React from 'react';

interface IProps {
	platform: string;
	click?: boolean;
}

const PLATFORMS = [
	{
		id: 'youtube',
		name: 'YouTube',
		url: 'https://youtube.com',
	},
	{
		id: 'instagram',
		name: 'Instagram',
		url: 'https://instagram.com',
	},
	{
		id: 'tiktok',
		name: 'TikTok',
		url: 'https://tiktok.com',
	},
	// {
	//   id: "twitter",
	//   name: "Twitter",
	//   searchArea: "key",
	//   searchKey: "playAddr",
	//   url: "https://twitter.com",
	// },
	// {
	//   id: "x",
	//   name: "Twitter",
	//   url: "https://x.com",
	// },
	// {
	//   id: "linkedin",
	//   name: "LinkedIn",
	//   url: "https://linkedin.com",
	// },
];

const Platforms = ({ platform }: IProps) => {
	switch (true) {
		case platform?.toLowerCase().includes('youtube'):
			return <Youtube />;
		case platform?.toLowerCase().includes('instagram'):
			return <Instagram />;
		case platform?.toLowerCase().includes('tiktok'):
			return <Tiktok />;
		case platform?.toLowerCase().includes('x.com'):
			return <Twitter />;
		case platform?.toLowerCase().includes('linkedin'):
			return <Linkedin />;

		default:
			return <span>{''}</span>;
	}
};

export default Platforms;

const Youtube = () => {
	return (
		<svg
			width="26"
			height="26"
			viewBox="0 0 26 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="26" height="25" rx="12.5" fill="#323232" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.6603 7.79773C19.2992 7.96364 19.8014 8.44773 19.9711 9.06136C20.28 10.175 20.28 12.5 20.28 12.5C20.28 12.5 20.28 14.825 19.9711 15.9386C19.799 16.5545 19.2968 17.0386 18.6603 17.2023C17.505 17.5 12.87 17.5 12.87 17.5C12.87 17.5 8.23724 17.5 7.07965 17.2023C6.44073 17.0364 5.93856 16.5523 5.76881 15.9386C5.45996 14.825 5.45996 12.5 5.45996 12.5C5.45996 12.5 5.45996 10.175 5.76881 9.06136C5.94092 8.44545 6.44309 7.96136 7.07965 7.79773C8.23724 7.5 12.87 7.5 12.87 7.5C12.87 7.5 17.505 7.5 18.6603 7.79773ZM15.2394 12.5L11.3894 14.6432V10.3568L15.2394 12.5Z"
				fill="white"
			/>
		</svg>
	);
};

const Instagram = () => {
	return (
		<svg
			width="25"
			height="26"
			viewBox="0 0 25 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="25" height="25" rx="12.5" fill="#323232" />
			<path
				d="M10.3038 12.576C10.3038 11.3194 11.3227 10.3005 12.5801 10.3005C13.8374 10.3005 14.857 11.3194 14.857 12.576C14.857 13.8326 13.8374 14.8515 12.5801 14.8515C11.3227 14.8515 10.3038 13.8326 10.3038 12.576ZM9.07292 12.576C9.07292 14.5118 10.6431 16.0811 12.5801 16.0811C14.5171 16.0811 16.0873 14.5118 16.0873 12.576C16.0873 10.6401 14.5171 9.07093 12.5801 9.07093C10.6431 9.07093 9.07292 10.6401 9.07292 12.576ZM15.4065 8.93195C15.4064 9.09396 15.4544 9.25234 15.5444 9.38708C15.6344 9.52182 15.7624 9.62686 15.9121 9.68892C16.0619 9.75098 16.2267 9.76726 16.3857 9.73572C16.5447 9.70418 16.6907 9.62622 16.8054 9.51171C16.9201 9.3972 16.9982 9.25128 17.0299 9.0924C17.0616 8.93352 17.0454 8.76882 16.9834 8.61912C16.9215 8.46942 16.8165 8.34145 16.6817 8.25139C16.547 8.16133 16.3885 8.11322 16.2264 8.11316H16.2261C16.0088 8.11326 15.8004 8.19955 15.6468 8.35307C15.4931 8.50659 15.4067 8.71479 15.4065 8.93195ZM9.82073 18.1322C9.15482 18.1019 8.79289 17.991 8.55236 17.8974C8.23347 17.7733 8.00595 17.6255 7.76673 17.3868C7.52752 17.148 7.37944 16.9209 7.25584 16.6022C7.16208 16.3619 7.05116 16.0001 7.02089 15.3346C6.98778 14.6151 6.98116 14.3989 6.98116 12.576C6.98116 10.7532 6.98832 10.5376 7.02089 9.81753C7.05121 9.15202 7.16295 8.7909 7.25584 8.54991C7.37999 8.23122 7.52784 8.00383 7.76673 7.76476C8.00562 7.52569 8.23293 7.3777 8.55236 7.25418C8.79278 7.16047 9.15482 7.04961 9.82073 7.01936C10.5407 6.98627 10.7569 6.97966 12.5801 6.97966C14.4032 6.97966 14.6197 6.98681 15.3403 7.01936C16.0062 7.04967 16.3675 7.16134 16.6086 7.25418C16.9275 7.3777 17.155 7.52601 17.3943 7.76476C17.6335 8.00351 17.781 8.23122 17.9051 8.54991C17.9989 8.79019 18.1098 9.15202 18.1401 9.81753C18.1732 10.5376 18.1798 10.7532 18.1798 12.576C18.1798 14.3989 18.1732 14.6144 18.1401 15.3346C18.1098 16.0001 17.9983 16.3618 17.9051 16.6022C17.781 16.9209 17.6331 17.1483 17.3943 17.3868C17.1554 17.6253 16.9275 17.7733 16.6086 17.8974C16.3682 17.9911 16.0062 18.1019 15.3403 18.1322C14.6203 18.1653 14.404 18.1719 12.5801 18.1719C10.7561 18.1719 10.5405 18.1653 9.82073 18.1322ZM9.76418 5.79134C9.03707 5.82443 8.54023 5.93965 8.10632 6.10839C7.65696 6.28265 7.27655 6.51642 6.89642 6.89573C6.51628 7.27504 6.28297 7.65582 6.10861 8.10491C5.93977 8.53883 5.82448 9.0351 5.79136 9.76177C5.7577 10.4896 5.75 10.7223 5.75 12.576C5.75 14.4297 5.7577 14.6624 5.79136 15.3902C5.82448 16.1169 5.93977 16.6132 6.10861 17.0471C6.28297 17.4959 6.51634 17.8771 6.89642 18.2563C7.2765 18.6354 7.65696 18.8688 8.10632 19.0436C8.54105 19.2123 9.03707 19.3275 9.76418 19.3606C10.4928 19.3937 10.7253 19.402 12.5801 19.402C14.4349 19.402 14.6677 19.3943 15.396 19.3606C16.1232 19.3275 16.6197 19.2123 17.0538 19.0436C17.5029 18.8688 17.8836 18.6356 18.2638 18.2563C18.6439 17.8769 18.8767 17.4959 19.0516 17.0471C19.2204 16.6132 19.3362 16.1169 19.3688 15.3902C19.4019 14.6618 19.4096 14.4297 19.4096 12.576C19.4096 10.7223 19.4019 10.4896 19.3688 9.76177C19.3357 9.03505 19.2204 8.53855 19.0516 8.10491C18.8767 7.65609 18.6433 7.27564 18.2638 6.89573C17.8842 6.51582 17.5029 6.28265 17.0544 6.10839C16.6197 5.93965 16.1231 5.82388 15.3965 5.79134C14.6683 5.75825 14.4355 5.75 12.5806 5.75C10.7258 5.75 10.4928 5.7577 9.76418 5.79134Z"
				fill="white"
			/>
		</svg>
	);
};

const Tiktok = () => {
	return (
		<svg
			width="25"
			height="26"
			viewBox="0 0 25 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="25" height="25" rx="12.5" fill="#323232" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.0093 10.8886C15.776 11.4336 16.6941 11.7248 17.6347 11.7213V9.8571C17.4498 9.85761 17.2654 9.83782 17.0848 9.79807V11.2832C16.142 11.2849 15.2226 10.9903 14.4563 10.4412V14.2752C14.454 14.9043 14.2814 15.5211 13.957 16.0601C13.6326 16.5992 13.1683 17.0403 12.6134 17.3369C12.0586 17.6334 11.4338 17.7743 10.8054 17.7445C10.177 17.7147 9.5683 17.5155 9.04395 17.1678C9.52896 17.6585 10.1487 17.9943 10.8246 18.1326C11.5006 18.2709 12.2024 18.2055 12.8412 17.9446C13.4799 17.6838 14.0269 17.2393 14.4129 16.6674C14.7989 16.0955 15.0064 15.4219 15.0093 14.7319V10.8886ZM15.6898 8.98715C15.2999 8.56457 15.0607 8.02496 15.0093 7.4523V7.20996H14.4874C14.5519 7.57397 14.6923 7.92032 14.8994 8.22651C15.1066 8.53269 15.3759 8.79185 15.6898 8.98715ZM10.2526 15.692C10.0716 15.4554 9.96078 15.1728 9.93257 14.8763C9.90437 14.5798 9.95996 14.2814 10.093 14.015C10.2261 13.7485 10.4313 13.5248 10.6852 13.3692C10.9392 13.2136 11.2317 13.1325 11.5295 13.135C11.6939 13.1349 11.8574 13.1601 12.0142 13.2095V11.2832C11.8309 11.2589 11.646 11.2485 11.4612 11.2521V12.7497C11.0794 12.629 10.6661 12.6564 10.3036 12.8266C9.94112 12.9967 9.65594 13.297 9.50479 13.6678C9.35365 14.0387 9.34762 14.4528 9.4879 14.8278C9.62818 15.2029 9.90449 15.5114 10.2619 15.692H10.2526Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.456 10.4288C15.2223 10.9779 16.1418 11.2724 17.0845 11.2708V9.78564C16.5474 9.67207 16.0595 9.39278 15.6895 8.98715C15.3756 8.79185 15.1063 8.53269 14.8992 8.22651C14.692 7.92032 14.5516 7.57397 14.4871 7.20996H13.1138V14.7319C13.1125 15.0649 13.007 15.3891 12.8121 15.659C12.6172 15.9289 12.3426 16.131 12.0269 16.2369C11.7113 16.3428 11.3704 16.3472 11.0521 16.2495C10.7338 16.1518 10.4541 15.9568 10.2523 15.692C9.93244 15.5306 9.67628 15.2662 9.52516 14.9413C9.37403 14.6165 9.33675 14.2502 9.41933 13.9016C9.50191 13.553 9.69952 13.2424 9.9803 13.0199C10.2611 12.7973 10.6086 12.6759 10.9669 12.6751C11.1313 12.6757 11.2946 12.7008 11.4516 12.7497V11.2521C10.7735 11.2684 10.115 11.4823 9.55674 11.8676C8.99853 12.2529 8.56495 12.7928 8.30925 13.421C8.05354 14.0492 7.98682 14.7384 8.11729 15.404C8.24776 16.0696 8.56973 16.6826 9.04368 17.1678C9.56814 17.518 10.1778 17.7193 10.8076 17.7504C11.4374 17.7814 12.0639 17.6411 12.6203 17.3442C13.1766 17.0474 13.6421 16.6052 13.967 16.0647C14.2919 15.5243 14.4641 14.9058 14.4653 14.2752L14.456 10.4288Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.0845 9.78564L17.0847 9.38471C16.5914 9.38681 16.1078 9.24904 15.6898 8.98715C16.0588 9.39395 16.5469 9.67347 17.0845 9.78564ZM14.4874 7.20996C14.4874 7.1385 14.4655 7.0638 14.4562 6.99234V6.75H12.5609V14.2751C12.5593 14.6965 12.3906 15.0999 12.0917 15.397C11.7929 15.6941 11.3884 15.8605 10.9671 15.8596C10.719 15.8609 10.4742 15.8035 10.2526 15.692C10.4544 15.9568 10.7338 16.1518 11.0521 16.2495C11.3704 16.3472 11.7113 16.3428 12.0269 16.2369C12.3426 16.131 12.6172 15.9289 12.8121 15.659C13.007 15.3891 13.1125 15.0649 13.1138 14.7319V7.20996H14.4874ZM11.4518 11.2489V10.8232C10.6719 10.7173 9.87909 10.8786 9.20263 11.2809C8.52617 11.6832 8.00591 12.3028 7.72664 13.0386C7.44736 13.7744 7.42555 14.5832 7.66475 15.333C7.90395 16.0828 8.39015 16.7296 9.04395 17.1678C8.57358 16.6815 8.25495 16.0686 8.12714 15.4042C7.99934 14.7398 8.06781 14.0526 8.32418 13.4265C8.58056 12.8004 9.01374 12.2625 9.57081 11.8785C10.1279 11.4946 10.7847 11.2812 11.4611 11.2644L11.4518 11.2489Z"
				fill="white"
			/>
		</svg>
	);
};

const Twitter = () => {
	return (
		<svg
			fill="#000000"
			height="26"
			width="25"
			version="1.1"
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="-143 145 512 512"
		>
			<path
				d="M113,145c-141.4,0-256,114.6-256,256s114.6,256,256,256s256-114.6,256-256S254.4,145,113,145z M215.2,361.2
	c0.1,2.2,0.1,4.5,0.1,6.8c0,69.5-52.9,149.7-149.7,149.7c-29.7,0-57.4-8.7-80.6-23.6c4.1,0.5,8.3,0.7,12.6,0.7
	c24.6,0,47.3-8.4,65.3-22.5c-23-0.4-42.5-15.6-49.1-36.5c3.2,0.6,6.5,0.9,9.9,0.9c4.8,0,9.5-0.6,13.9-1.9
	C13.5,430-4.6,408.7-4.6,383.2v-0.6c7.1,3.9,15.2,6.3,23.8,6.6c-14.1-9.4-23.4-25.6-23.4-43.8c0-9.6,2.6-18.7,7.1-26.5
	c26,31.9,64.7,52.8,108.4,55c-0.9-3.8-1.4-7.8-1.4-12c0-29,23.6-52.6,52.6-52.6c15.1,0,28.8,6.4,38.4,16.6
	c12-2.4,23.2-6.7,33.4-12.8c-3.9,12.3-12.3,22.6-23.1,29.1c10.6-1.3,20.8-4.1,30.2-8.3C234.4,344.5,225.5,353.7,215.2,361.2z"
			/>
		</svg>
	);
};

const Linkedin = () => {
	return (
		<svg
			fill="#000000"
			height="26"
			width="25"
			version="1.1"
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			// xmlns:xlink="http://www.w3.org/1999/xlink"
			viewBox="-143 145 512 512"
			// xml:space="preserve"
		>
			<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
			<g
				id="SVGRepo_tracerCarrier"
				stroke-linecap="round"
				stroke-linejoin="round"
			></g>
			<g id="SVGRepo_iconCarrier">
				{' '}
				<path d="M113,145c-141.4,0-256,114.6-256,256s114.6,256,256,256s256-114.6,256-256S254.4,145,113,145z M41.4,508.1H-8.5V348.4h49.9 V508.1z M15.1,328.4h-0.4c-18.1,0-29.8-12.2-29.8-27.7c0-15.8,12.1-27.7,30.5-27.7c18.4,0,29.7,11.9,30.1,27.7 C45.6,316.1,33.9,328.4,15.1,328.4z M241,508.1h-56.6v-82.6c0-21.6-8.8-36.4-28.3-36.4c-14.9,0-23.2,10-27,19.6 c-1.4,3.4-1.2,8.2-1.2,13.1v86.3H71.8c0,0,0.7-146.4,0-159.7h56.1v25.1c3.3-11,21.2-26.6,49.8-26.6c35.5,0,63.3,23,63.3,72.4V508.1z "></path>{' '}
			</g>
		</svg>
	);
};

export { Youtube, Tiktok, Instagram, PLATFORMS };
